import { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { checkAuth } from '../utils/authCheck'

export default function ProfileMiddleware({ children }) {
    const [isValid, setIsValid] = useState(null);

    useEffect(() => {
        const validate = async () => {
            const accessToken = localStorage.getItem('accessToken');

            if (!accessToken) {
                setIsValid(false);
                return;
            }

            try {
                const data = await checkAuth();

                if (data.status === 'deleted') {
                    setIsValid(false);
                    return;
                }

                setIsValid(true);
            } catch {
                // Сетевая ошибка/5xx при проверке ≠ мёртвая сессия: токен есть —
                // пускаем, явный deleted всплывёт при первом же API-запросе.
                setIsValid(true);
            }
        }

        validate();
    }, [])

    if (isValid === null) return null;
    if (!isValid) return <Navigate to="/" replace />;

    return children;
}
